(ns frontend.ux-overhaul.components.filter.view
  (:require
   [reagent.core :as r]
   [clojure.string :as string]))

(defn filter-bubble
  []
  (let [state-atom (r/atom {:hover? false})]
    (fn [{:keys [text
                 on-click! on-edit! on-delete!]}]
      (let [text (or text "")
            [field value] (string/split text #":")]
        [:div
         {:on-mouse-enter #(swap! state-atom assoc :hover? true)
          :on-mouse-leave #(swap! state-atom assoc :hover? false)
          :on-click       (when (fn? on-click!) on-click!)
          :class          "min-12 py-1 px-3 flex justify-center items-center gap-3 group
                           text-base-light-text
                           border border-solid border-base-light-border hover:border-base-light-border-accent rounded-full ease-in"
          :style          {:cursor (when (fn? on-click!) "pointer")}}
         [:span
          {:class "m-0 flex flex-col text-xs "}
          [:span
           {:class "text-xs font-semibold text-base-light-text-paler"}
           field]
          [:span 
           {:class "leading-3"}
           value]]

         [:div
          {:class "hidden group-hover:flex gap-2 text-xs hover:text-base-light-text-accent"}
          [:i.fal.fa-pen
           {:on-click (when (fn? on-edit!) on-edit!)}]
          [:i.fal.fa-times
           {:on-click (when (fn? on-delete!) on-delete!)}]]]))))
